import type { StrictScalar } from "@/lib/reports";

/** What a reader sees of a value the report does not carry. */
export const MISSING = "—";

/** A table cell or KPI value, worded as the rendered report words it: a missing
 * value as "—", a boolean as "Sí" or "No", anything else as it is written. The
 * rendered report and the text a revision comparison reads share this wording, so
 * a changed value reads the same in both. */
export function scalar(value: StrictScalar | undefined): string {
  if (value === null || value === undefined) return MISSING;
  if (typeof value === "boolean") return value ? "Sí" : "No";
  return String(value);
}

/** The exhaustiveness check of a switch over the report's block types: a block
 * type added to the schema is a compile error where it is not handled, and a
 * runtime error for one that slips past the parser. */
export function assertNever(value: never): never {
  throw new Error(`Unsupported report block: ${JSON.stringify(value)}`);
}
